// const htmlBody = document.querySelector('#filmConsider_card').querySelector('div[name=chatBody]');
import auth from '../tools/storage.js';
// import auth from '../tools/storage.js';

import tools from '../tools/tools.js';
export default {

  cleanContainer(htmlBody) {
    htmlBody.innerHTML = '<div></div>';
  },

  getElement(item, index , newMsg, fullMode) {
    let msgsBody = '';
    let iRemoveBlock = '';
    let viewedStatus = '';

    if(item.details)
    {
      item.details.forEach((item, index) => {
        viewedStatus = '';
        if(item.viewed) {
          let viewedInt = parseInt(item.viewed, 10);
          if(viewedInt === 1)
            viewedStatus = 'Просмотрено через e-mail';
          else if(viewedInt === 2)
            viewedStatus = 'Просмотрено через смс';
          else if(viewedInt === 3)
            viewedStatus = 'Просмотрено в личном кабинете';

          if(item.timeViewed)
            viewedStatus = `${viewedStatus} - ${tools.dateStringFull(item.timeViewed)}`;
          else if (viewedInt === 1)
            viewedStatus = 'Просмотрено в личном кабинете';
            
        } 

         if(parseInt(auth.data.operatorId, 10) === parseInt(item.uid,10) && viewedStatus.length < 2)
            iRemoveBlock = ` <i class="ml-auto mr-3 mt-1" name="removeMsg" msgID="${item.mtoken}" >Удалить сообщение</i>`;
          else
            iRemoveBlock = ``;

        let nameClassMsg = 'msg_org';
        if (parseInt(item.uid) == 11) 
          nameClassMsg = 'msg_system';
        else if (item.mail){
          
          if(parseInt(item.fmDeviceType) == 1)
            nameClassMsg = 'msg_creator_email';
          else
            nameClassMsg = 'msg_creator';
         }
      


          msgsBody += `<div class = "${nameClassMsg} mb-1"> ${tools.texWithLinks(item.text)}
                        <small class="row w-100 m-0 p-1 mt-1">
                          ${parseInt(item.fmDeviceType) == 1 ? ' <i>Ответ через системную почту! (вложения не поддерживаются)</i>':''} 
                          <i class="ml-1 mr-auto mt-1">${viewedStatus}</i>
                          <div class ="ml-auto mr-1 mt-1">
                          ${iRemoveBlock} ${(item.name) ? (`${item.name}  ` ) :''}  ${(item.phone && item.phone > 5) ?  tools.formatedPhone(item.phone) : ' '}  ${(item.mail) ? (item.mail) : ' '} </div>
                          <b class="ml-1 mr-1">${tools.dateStringFull(item.time)}</b>
                        </small>
                      </div>`;
      });
    }

    if(msgsBody.length < 1)
      msgsBody = '<label class="mlr-auto mt-1 w-80">Используйте данный чат для обмена информацией не связанной с замечаниями по заявке:<br> - Обсуждения организационных вопросов.<br> - Рассылки напоминаний.<br> - Информировании об просиходящих изменениях. </label>';


  let inputWithButton  = '';
  let arrPremissions = JSON.parse(auth.permissionsOnFest);
    
    //0 - блок спрятан
    //1 - ограниченное действие  - только просмотр
    //2 - полное взаимодействие
  if (parseInt(arrPremissions['cardTabChats'], 10) == 2 && fullMode ) 
    inputWithButton = `     
            <div class="row m-0 p-0">
              <input type="text" class="w-80 ml-1 coommentAddInput" name="remark-${item.remarkID}-input">
              <button class="w-15 ml-auto mr-auto coommentAddBT btn " type="button" name="sendMsg" remarkID=${item.remarkID}>Отправить</button>
            </div>
            `;



  return `<div class = " column w-100 m-0 p-3}">
            ${fullMode ? '<h5 class="w-100 txt-al-center">Чат с владельцем заявки</h5>' : ''}
            <div class="w-100 m-0 p-3 column" style="min-height: 200px;">
              ${msgsBody}  
            </div>
            ${inputWithButton}
          </div>`;
  },

  ifnull (someData) {
    return (someData)? someData : '';
  },

  drawDataInContainer(dataToDisplay, arrNotification, htmlBody, fullMode = true) {

 
    this.cleanContainer(htmlBody);
    if(dataToDisplay){
      if(dataToDisplay.length== 0){
        htmlBody.innerHTML = '<button type="button" class="coommentAddBT btn addChat w-30 mlr-auto mt-5" name="createNewChat">Начать чат с владельцем заявки</button>';
      } else
       dataToDisplay.forEach((item, index) => {
        let newMsg = false;
        // if(arrNotification)
        //   arrNotification.forEach((nItem, nIndex) => {
        //     if(item.remarkID === nItem.remarkID)
        //       newMsg = true;
        //   });
        htmlBody.insertAdjacentHTML('beforeend', this.getElement(item, index, newMsg, fullMode));
       });
    }

  },

  drawMarkupInContainer(markup) {
    // htmlBody.insertAdjacentHTML('beforeend', markup);
  },

};
